import React from 'react';
import { WidthProvider, Responsive } from 'react-grid-layout'
import DeviceTableHandler from '../handlers/deviceTable-handler';
import EventNewsfeedHandler from '../handlers/eventNewsfeed-handler';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { Layout } from '../atoms-types/layout';

const ResponsiveGridLayout = WidthProvider(Responsive);

const EventGrid: React.FC = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const layout: Layout[] = [
    { i: 'a', x: 0, y: 0, w: 9, h: 8, minW: 7, minH: 5 },
    { i: 'b', x: 1, y: 7, w: 7, h: 5, minW: 7, minH: 2 },
  ];

  return (
    <Box 
      sx={{ 
        position: 'relative',
        height: '100vh',
        width: '100%',
        overflowY: isSmallScreen ? 'auto' : 'visible',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#888',
          borderRadius: '4px',
          '&:hover': {
            background: '#555',
          },
        },
      }}
    >
      <Box sx={{ minHeight: '100%', width: '100%' }}>
        <ResponsiveGridLayout 
          className="layout" 
          layouts={{ lg: layout }} 
          breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480 }} 
          cols={{ lg: 9, md: 6, sm: 3, xs: 1 }}
          rowHeight={100}
          draggableCancel=".cancelSelectorName"
          isDraggable={false}
          isResizable={false}
        >
          <div key="a" style={{ minHeight: "600px", overflow: "hidden", display: 'flex', flexDirection: 'column' }}>
            <div style={{ overflowY: "auto" }}>
              <EventNewsfeedHandler/>
            </div>
          </div>
          <div key="b" style={{ minHeight: "500px" }} className='card-gauge'>
          </div>
        </ResponsiveGridLayout>
      </Box>
    </Box>
  );
};

export default EventGrid;

